
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { FileSaverModule } from 'ngx-filesaver';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../factories/http-loader.factory';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
// <primeng-modules>
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FocusTrapModule } from 'primeng/focustrap';
import { FullCalendarModule } from 'primeng/fullcalendar';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SpinnerModule } from 'primeng/spinner';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
// </primeng-modules>
import { EfitRoutingModule } from './efit.routing';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { TableCellValueComponent } from './components/table-cell-value/table-cell-value.component';
import { FilerComponent, DialogFilerComponent } from './components/filer/filer.component';
import { AgeRangesComponent } from './components/age-ranges/age-ranges.component';
import { AgeRangeFormComponent, DialogAgeRangeFormComponent } from './components/age-ranges/age-range-form/age-range-form.component';
import { AgeRangeDetailsComponent, DialogAgeRangeDetailsComponent } from './components/age-ranges/age-range-details/age-range-details.component';
import { BannersComponent } from './components/banners/banners.component';
import { BannerFormComponent, DialogBannerFormComponent } from './components/banners/banner-form/banner-form.component';
import { BannerDetailsComponent, DialogBannerDetailsComponent } from './components/banners/banner-details/banner-details.component';
import { BannerPositionsComponent } from './components/banner-positions/banner-positions.component';
import { BannerPositionFormComponent, DialogBannerPositionFormComponent } from './components/banner-positions/banner-position-form/banner-position-form.component';
import { BannerPositionDetailsComponent, DialogBannerPositionDetailsComponent } from './components/banner-positions/banner-position-details/banner-position-details.component';
import { BannerTypesComponent } from './components/banner-types/banner-types.component';
import { BannerTypeFormComponent, DialogBannerTypeFormComponent } from './components/banner-types/banner-type-form/banner-type-form.component';
import { BannerTypeDetailsComponent, DialogBannerTypeDetailsComponent } from './components/banner-types/banner-type-details/banner-type-details.component';
import { CitiesComponent } from './components/cities/cities.component';
import { CityFormComponent, DialogCityFormComponent } from './components/cities/city-form/city-form.component';
import { CityDetailsComponent, DialogCityDetailsComponent } from './components/cities/city-details/city-details.component';
import { ClassDurationsComponent } from './components/class-durations/class-durations.component';
import { ClassDurationFormComponent, DialogClassDurationFormComponent } from './components/class-durations/class-duration-form/class-duration-form.component';
import { ClassDurationDetailsComponent, DialogClassDurationDetailsComponent } from './components/class-durations/class-duration-details/class-duration-details.component';
import { ClicksComponent } from './components/clicks/clicks.component';
import { ClickFormComponent, DialogClickFormComponent } from './components/clicks/click-form/click-form.component';
import { ClickDetailsComponent, DialogClickDetailsComponent } from './components/clicks/click-details/click-details.component';
import { CoachesComponent } from './components/coaches/coaches.component';
import { CoachFormComponent, DialogCoachFormComponent } from './components/coaches/coach-form/coach-form.component';
import { CoachDetailsComponent, DialogCoachDetailsComponent } from './components/coaches/coach-details/coach-details.component';
import { CommentsComponent } from './components/comments/comments.component';
import { CommentFormComponent, DialogCommentFormComponent } from './components/comments/comment-form/comment-form.component';
import { CommentDetailsComponent, DialogCommentDetailsComponent } from './components/comments/comment-details/comment-details.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { CompanyFormComponent, DialogCompanyFormComponent } from './components/companies/company-form/company-form.component';
import { CompanyDetailsComponent, DialogCompanyDetailsComponent } from './components/companies/company-details/company-details.component';
import { CountriesComponent } from './components/countries/countries.component';
import { CountryFormComponent, DialogCountryFormComponent } from './components/countries/country-form/country-form.component';
import { CountryDetailsComponent, DialogCountryDetailsComponent } from './components/countries/country-details/country-details.component';
import { FavoritesComponent } from './components/favorites/favorites.component';
import { FavoriteFormComponent, DialogFavoriteFormComponent } from './components/favorites/favorite-form/favorite-form.component';
import { FavoriteDetailsComponent, DialogFavoriteDetailsComponent } from './components/favorites/favorite-details/favorite-details.component';
import { FitnessClassesComponent } from './components/fitness-classes/fitness-classes.component';
import { FitnessClassFormComponent, DialogFitnessClassFormComponent } from './components/fitness-classes/fitness-class-form/fitness-class-form.component';
import { FitnessClassDetailsComponent, DialogFitnessClassDetailsComponent } from './components/fitness-classes/fitness-class-details/fitness-class-details.component';
import { FitnessGoalsComponent } from './components/fitness-goals/fitness-goals.component';
import { FitnessGoalFormComponent, DialogFitnessGoalFormComponent } from './components/fitness-goals/fitness-goal-form/fitness-goal-form.component';
import { FitnessGoalDetailsComponent, DialogFitnessGoalDetailsComponent } from './components/fitness-goals/fitness-goal-details/fitness-goal-details.component';
import { FitnessReservationsComponent } from './components/fitness-reservations/fitness-reservations.component';
import { FitnessReservationFormComponent, DialogFitnessReservationFormComponent } from './components/fitness-reservations/fitness-reservation-form/fitness-reservation-form.component';
import { FitnessReservationDetailsComponent, DialogFitnessReservationDetailsComponent } from './components/fitness-reservations/fitness-reservation-details/fitness-reservation-details.component';
import { FitnessSessionsComponent } from './components/fitness-sessions/fitness-sessions.component';
import { FitnessSessionFormComponent, DialogFitnessSessionFormComponent } from './components/fitness-sessions/fitness-session-form/fitness-session-form.component';
import { FitnessSessionDetailsComponent, DialogFitnessSessionDetailsComponent } from './components/fitness-sessions/fitness-session-details/fitness-session-details.component';
import { ImpressionsComponent } from './components/impressions/impressions.component';
import { ImpressionFormComponent, DialogImpressionFormComponent } from './components/impressions/impression-form/impression-form.component';
import { ImpressionDetailsComponent, DialogImpressionDetailsComponent } from './components/impressions/impression-details/impression-details.component';
import { IntensitiesComponent } from './components/intensities/intensities.component';
import { IntensityFormComponent, DialogIntensityFormComponent } from './components/intensities/intensity-form/intensity-form.component';
import { IntensityDetailsComponent, DialogIntensityDetailsComponent } from './components/intensities/intensity-details/intensity-details.component';
import { LanguagesComponent } from './components/languages/languages.component';
import { LanguageFormComponent, DialogLanguageFormComponent } from './components/languages/language-form/language-form.component';
import { LanguageDetailsComponent, DialogLanguageDetailsComponent } from './components/languages/language-details/language-details.component';
import { LikesComponent } from './components/likes/likes.component';
import { LikeFormComponent, DialogLikeFormComponent } from './components/likes/like-form/like-form.component';
import { LikeDetailsComponent, DialogLikeDetailsComponent } from './components/likes/like-details/like-details.component';
import { LiveChannelsComponent } from './components/live-channels/live-channels.component';
import { LiveChannelFormComponent, DialogLiveChannelFormComponent } from './components/live-channels/live-channel-form/live-channel-form.component';
import { LiveChannelDetailsComponent, DialogLiveChannelDetailsComponent } from './components/live-channels/live-channel-details/live-channel-details.component';
import { LogsComponent } from './components/logs/logs.component';
import { LogFormComponent, DialogLogFormComponent } from './components/logs/log-form/log-form.component';
import { LogDetailsComponent, DialogLogDetailsComponent } from './components/logs/log-details/log-details.component';
import { MembersComponent } from './components/members/members.component';
import { MemberFormComponent, DialogMemberFormComponent } from './components/members/member-form/member-form.component';
import { MemberDetailsComponent, DialogMemberDetailsComponent } from './components/members/member-details/member-details.component';
import { SportsComponent } from './components/sports/sports.component';
import { SportFormComponent, DialogSportFormComponent } from './components/sports/sport-form/sport-form.component';
import { SportDetailsComponent, DialogSportDetailsComponent } from './components/sports/sport-details/sport-details.component';
import { PacksComponent } from './components/packs/packs.component';
import { PackFormComponent, DialogPackFormComponent } from './components/packs/pack-form/pack-form.component';
import { PackDetailsComponent, DialogPackDetailsComponent } from './components/packs/pack-details/pack-details.component';
import { PackageTypesComponent } from './components/package-types/package-types.component';
import { PackageTypeFormComponent, DialogPackageTypeFormComponent } from './components/package-types/package-type-form/package-type-form.component';
import { PackageTypeDetailsComponent, DialogPackageTypeDetailsComponent } from './components/package-types/package-type-details/package-type-details.component';
import { PostsComponent } from './components/posts/posts.component';
import { PostFormComponent, DialogPostFormComponent } from './components/posts/post-form/post-form.component';
import { PostDetailsComponent, DialogPostDetailsComponent } from './components/posts/post-details/post-details.component';
import { PostTypesComponent } from './components/post-types/post-types.component';
import { PostTypeFormComponent, DialogPostTypeFormComponent } from './components/post-types/post-type-form/post-type-form.component';
import { PostTypeDetailsComponent, DialogPostTypeDetailsComponent } from './components/post-types/post-type-details/post-type-details.component';
import { PricesComponent } from './components/prices/prices.component';
import { PriceFormComponent, DialogPriceFormComponent } from './components/prices/price-form/price-form.component';
import { PriceDetailsComponent, DialogPriceDetailsComponent } from './components/prices/price-details/price-details.component';
import { RatingsComponent } from './components/ratings/ratings.component';
import { RatingFormComponent, DialogRatingFormComponent } from './components/ratings/rating-form/rating-form.component';
import { RatingDetailsComponent, DialogRatingDetailsComponent } from './components/ratings/rating-details/rating-details.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { ReviewFormComponent, DialogReviewFormComponent } from './components/reviews/review-form/review-form.component';
import { ReviewDetailsComponent, DialogReviewDetailsComponent } from './components/reviews/review-details/review-details.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SettingFormComponent, DialogSettingFormComponent } from './components/settings/setting-form/setting-form.component';
import { SettingDetailsComponent, DialogSettingDetailsComponent } from './components/settings/setting-details/setting-details.component';
import { SharingsComponent } from './components/sharings/sharings.component';
import { SharingFormComponent, DialogSharingFormComponent } from './components/sharings/sharing-form/sharing-form.component';
import { SharingDetailsComponent, DialogSharingDetailsComponent } from './components/sharings/sharing-details/sharing-details.component';
import { ShowsComponent } from './components/shows/shows.component';
import { ShowFormComponent, DialogShowFormComponent } from './components/shows/show-form/show-form.component';
import { ShowDetailsComponent, DialogShowDetailsComponent } from './components/shows/show-details/show-details.component';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { SubscriptionFormComponent, DialogSubscriptionFormComponent } from './components/subscriptions/subscription-form/subscription-form.component';
import { SubscriptionDetailsComponent, DialogSubscriptionDetailsComponent } from './components/subscriptions/subscription-details/subscription-details.component';
import { UsersComponent } from './components/users/users.component';
import { UserFormComponent, DialogUserFormComponent } from './components/users/user-form/user-form.component';
import { UserDetailsComponent, DialogUserDetailsComponent } from './components/users/user-details/user-details.component';
import { VideosComponent } from './components/videos/videos.component';
import { VideoFormComponent, DialogVideoFormComponent } from './components/videos/video-form/video-form.component';
import { VideoDetailsComponent, DialogVideoDetailsComponent } from './components/videos/video-details/video-details.component';
import { VideoConverterComponent, DialogVideoConverterComponent } from './components/videos/video-converter/video-converter.component';
import { VideoCategoriesComponent } from './components/video-categories/video-categories.component';
import { VideoCategoryFormComponent, DialogVideoCategoryFormComponent } from './components/video-categories/video-category-form/video-category-form.component';
import { VideoCategoryDetailsComponent, DialogVideoCategoryDetailsComponent } from './components/video-categories/video-category-details/video-category-details.component';
import { VideoTypesComponent } from './components/video-types/video-types.component';
import { VideoTypeFormComponent, DialogVideoTypeFormComponent } from './components/video-types/video-type-form/video-type-form.component';
import { VideoTypeDetailsComponent, DialogVideoTypeDetailsComponent } from './components/video-types/video-type-details/video-type-details.component';
import { VisitsComponent } from './components/visits/visits.component';
import { VisitFormComponent, DialogVisitFormComponent } from './components/visits/visit-form/visit-form.component';
import { VisitDetailsComponent, DialogVisitDetailsComponent } from './components/visits/visit-details/visit-details.component';
import { ChallengesComponent } from './components/challenges/challenges.component';
import { ChallengeFormComponent, DialogChallengeFormComponent } from './components/challenges/challenge-form/challenge-form.component';
import { ChallengeDetailsComponent, DialogChallengeDetailsComponent } from './components/challenges/challenge-details/challenge-details.component';



@NgModule({
  declarations: [
    SafeHtmlPipe,
    DashboardComponent,
    ProfileComponent,
    ChangePasswordComponent,
    LoginComponent,
    LogoutComponent,
    ForgotPasswordComponent,
    TableCellValueComponent,
    FilerComponent,
    DialogFilerComponent,
    AgeRangesComponent,
    AgeRangeFormComponent,
    DialogAgeRangeFormComponent,
    AgeRangeDetailsComponent,
    DialogAgeRangeDetailsComponent,
    BannersComponent,
    BannerFormComponent,
    DialogBannerFormComponent,
    BannerDetailsComponent,
    DialogBannerDetailsComponent,
    BannerPositionsComponent,
    BannerPositionFormComponent,
    DialogBannerPositionFormComponent,
    BannerPositionDetailsComponent,
    DialogBannerPositionDetailsComponent,
    BannerTypesComponent,
    BannerTypeFormComponent,
    DialogBannerTypeFormComponent,
    BannerTypeDetailsComponent,
    DialogBannerTypeDetailsComponent,
    CitiesComponent,
    CityFormComponent,
    DialogCityFormComponent,
    CityDetailsComponent,
    DialogCityDetailsComponent,
    ClassDurationsComponent,
    ClassDurationFormComponent,
    DialogClassDurationFormComponent,
    ClassDurationDetailsComponent,
    DialogClassDurationDetailsComponent,
    ClicksComponent,
    ClickFormComponent,
    DialogClickFormComponent,
    ClickDetailsComponent,
    DialogClickDetailsComponent,
    CoachesComponent,
    CoachFormComponent,
    DialogCoachFormComponent,
    CoachDetailsComponent,
    DialogCoachDetailsComponent,
    CommentsComponent,
    CommentFormComponent,
    DialogCommentFormComponent,
    CommentDetailsComponent,
    DialogCommentDetailsComponent,
    CompaniesComponent,
    CompanyFormComponent,
    DialogCompanyFormComponent,
    CompanyDetailsComponent,
    DialogCompanyDetailsComponent,
    CountriesComponent,
    CountryFormComponent,
    DialogCountryFormComponent,
    CountryDetailsComponent,
    DialogCountryDetailsComponent,
    FavoritesComponent,
    FavoriteFormComponent,
    DialogFavoriteFormComponent,
    FavoriteDetailsComponent,
    DialogFavoriteDetailsComponent,
    FitnessClassesComponent,
    FitnessClassFormComponent,
    DialogFitnessClassFormComponent,
    FitnessClassDetailsComponent,
    DialogFitnessClassDetailsComponent,
    FitnessGoalsComponent,
    FitnessGoalFormComponent,
    DialogFitnessGoalFormComponent,
    FitnessGoalDetailsComponent,
    DialogFitnessGoalDetailsComponent,
    FitnessReservationsComponent,
    FitnessReservationFormComponent,
    DialogFitnessReservationFormComponent,
    FitnessReservationDetailsComponent,
    DialogFitnessReservationDetailsComponent,
    FitnessSessionsComponent,
    FitnessSessionFormComponent,
    DialogFitnessSessionFormComponent,
    FitnessSessionDetailsComponent,
    DialogFitnessSessionDetailsComponent,
    ImpressionsComponent,
    ImpressionFormComponent,
    DialogImpressionFormComponent,
    ImpressionDetailsComponent,
    DialogImpressionDetailsComponent,
    IntensitiesComponent,
    IntensityFormComponent,
    DialogIntensityFormComponent,
    IntensityDetailsComponent,
    DialogIntensityDetailsComponent,
    LanguagesComponent,
    LanguageFormComponent,
    DialogLanguageFormComponent,
    LanguageDetailsComponent,
    DialogLanguageDetailsComponent,
    LikesComponent,
    LikeFormComponent,
    DialogLikeFormComponent,
    LikeDetailsComponent,
    DialogLikeDetailsComponent,
    LiveChannelsComponent,
    LiveChannelFormComponent,
    DialogLiveChannelFormComponent,
    LiveChannelDetailsComponent,
    DialogLiveChannelDetailsComponent,
    LogsComponent,
    LogFormComponent,
    DialogLogFormComponent,
    LogDetailsComponent,
    DialogLogDetailsComponent,
    MembersComponent,
    MemberFormComponent,
    DialogMemberFormComponent,
    MemberDetailsComponent,
    DialogMemberDetailsComponent,
    SportsComponent,
    SportFormComponent,
    DialogSportFormComponent,
    SportDetailsComponent,
    DialogSportDetailsComponent,
    PacksComponent,
    PackFormComponent,
    DialogPackFormComponent,
    PackDetailsComponent,
    DialogPackDetailsComponent,
    PackageTypesComponent,
    PackageTypeFormComponent,
    DialogPackageTypeFormComponent,
    PackageTypeDetailsComponent,
    DialogPackageTypeDetailsComponent,
    PostsComponent,
    PostFormComponent,
    DialogPostFormComponent,
    PostDetailsComponent,
    DialogPostDetailsComponent,
    PostTypesComponent,
    PostTypeFormComponent,
    DialogPostTypeFormComponent,
    PostTypeDetailsComponent,
    DialogPostTypeDetailsComponent,
    PricesComponent,
    PriceFormComponent,
    DialogPriceFormComponent,
    PriceDetailsComponent,
    DialogPriceDetailsComponent,
    RatingsComponent,
    RatingFormComponent,
    DialogRatingFormComponent,
    RatingDetailsComponent,
    DialogRatingDetailsComponent,
    ReviewsComponent,
    ReviewFormComponent,
    DialogReviewFormComponent,
    ReviewDetailsComponent,
    DialogReviewDetailsComponent,
    SettingsComponent,
    SettingFormComponent,
    DialogSettingFormComponent,
    SettingDetailsComponent,
    DialogSettingDetailsComponent,
    SharingsComponent,
    SharingFormComponent,
    DialogSharingFormComponent,
    SharingDetailsComponent,
    DialogSharingDetailsComponent,
    ShowsComponent,
    ShowFormComponent,
    DialogShowFormComponent,
    ShowDetailsComponent,
    DialogShowDetailsComponent,
    SubscriptionsComponent,
    SubscriptionFormComponent,
    DialogSubscriptionFormComponent,
    SubscriptionDetailsComponent,
    DialogSubscriptionDetailsComponent,
    UsersComponent,
    UserFormComponent,
    DialogUserFormComponent,
    UserDetailsComponent,
    DialogUserDetailsComponent,
    VideosComponent,
    VideoFormComponent,
    DialogVideoFormComponent,
    VideoDetailsComponent,
    DialogVideoDetailsComponent,
    VideoConverterComponent,
    DialogVideoConverterComponent,
    VideoCategoriesComponent,
    VideoCategoryFormComponent,
    DialogVideoCategoryFormComponent,
    VideoCategoryDetailsComponent,
    DialogVideoCategoryDetailsComponent,
    VideoTypesComponent,
    VideoTypeFormComponent,
    DialogVideoTypeFormComponent,
    VideoTypeDetailsComponent,
    DialogVideoTypeDetailsComponent,
    VisitsComponent,
    VisitFormComponent,
    DialogVisitFormComponent,
    VisitDetailsComponent,
    DialogVisitDetailsComponent,
    ChallengesComponent,
    ChallengeFormComponent,
    ChallengeDetailsComponent,
    DialogChallengeFormComponent,
    DialogChallengeDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    // FileSaverModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CKEditorModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    EfitRoutingModule,
    AccordionModule,
    AutoCompleteModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CarouselModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    CodeHighlighterModule,
    ConfirmDialogModule,
    ColorPickerModule,
    ContextMenuModule,
    DataViewModule,
    DialogModule,
    DropdownModule,
    DynamicDialogModule,
    EditorModule,
    FieldsetModule,
    FileUploadModule,
    FocusTrapModule,
    FullCalendarModule,
    GalleriaModule,
    InplaceModule,
    InputMaskModule,
    InputNumberModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    LightboxModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    OrderListModule,
    OrganizationChartModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    RippleModule,
    ScrollPanelModule,
    ScrollTopModule,
    SelectButtonModule,
    SidebarModule,
    SlideMenuModule,
    SliderModule,
    SpinnerModule,
    SplitButtonModule,
    StepsModule,
    TableModule,
    TabMenuModule,
    TabViewModule,
    TerminalModule,
    TieredMenuModule,
    ToastModule,
    ToggleButtonModule,
    ToolbarModule,
    TooltipModule,
    TreeModule,
    TreeTableModule,
    TriStateCheckboxModule,
    VirtualScrollerModule,
  ],
  exports: [
    SafeHtmlPipe
  ],
  providers: [
    ConfirmationService,
    DialogService,
    MessageService,
  ],
})
export class EfitModule { }

